
<template>
  <v-card v-if="attachment">
    <v-card-title>
      <v-avatar size=48>
        <v-icon color="primary" large>message</v-icon>
      </v-avatar>
      <span class="subheading pl-2">
        Delete attachment
      </span>
    </v-card-title>

    <v-card-text>
      <p class='subheading font-weight-medium'>
        Deleting this attachment will permanently remove it from the comment. This action cannot be undone.
      </p>

      <v-layout>
        <v-flex class="xs10 subheading">{{attachment.filename}}</v-flex>
        <v-flex class="xs2 subheading">{{attachment.filesize | toFileSize}}</v-flex>
      </v-layout>

      <br>
      <p class='subheading red--text'>
        Are you sure you want to delete this attachment ?
      </p>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="cancelDeleteAttachment()">Cancel</v-btn>
      <v-btn color="error" @click="deleteAttachment()">Delete</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'

  import commentService from '@/services/comment'

  export default {
    name: 'comment-attachment-delete',

    props: ['comment', 'attachment'],

    data () {
      return {
      }
    },

    computed: {
    },

    mounted () {
    },

    methods: {
      cancelDeleteAttachment () {
        EventBus.$emit('comment-attachment-deleted')
      },

      deleteAttachment () {
        commentService.deleteAttachment(
          (data) => {
            EventBus.$emit('comment-attachment-deleted', this.attachment)
          },
          (err) => {
            console.log(err)
          },
          this.comment.id,
          this.attachment.id
        )
      },

      validate () {
        if (this.$refs.form.validate()) {
          // TODO
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/comment/_attachment_delete.vue